import { styled } from 'styled'

import BaseText from '../text/BaseText'

const Info = styled(BaseText)`
  text-align: center;
`

export default Info
